export const FADE =
  'shrink-0 whitespace-nowrap transition-opacity duration-150';

export const PARENT_CLS =
  'flex h-9 items-center gap-md rounded-lg px-md text-[13px] font-medium transition-colors';

export const CHILD_CLS =
  'flex h-8 items-center gap-sm rounded-lg pl-xl pr-md text-[12px] font-medium transition-colors';

export const PARENT_ON = 'bg-brand-red/10 text-brand-red';
export const PARENT_OFF =
  'text-text-secondary hover:bg-surface-elevated hover:text-text-primary';
export const CHILD_ON = 'text-brand-red';
export const CHILD_OFF = 'text-text-tertiary hover:text-text-secondary';
